import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";

const initialState = {
	list: [],
	rejectReason: null,
	error: "",
	loading: false,
};

// ADD_rejectReason
export const addRejectReason = createAsyncThunk(
	"rejectReason/addRejectReason",
	async (values) => {
		try {
			const { data } = await axios({
				method: "post",
				url: `rejectReason`,
				data: {
					...values,
				},
			});
			toast.success("Reject Reason added successfully!");
			return {
				data,
				message: "success",
			};
		} catch (error) {
			toast.error("Error in adding Reject Reason try again");
			console.log(error.message);
			return {
				message: "error",
			};
		}
	}
);

// DELETE_rejectReason
export const deleteRejectReason = createAsyncThunk(
	"rejectReason/deleteRejectReason ",
	async (id) => {
		try {
			const resp = await axios({
				method: "delete",
				headers: {
					Accept: "application/json",
					"Content-Type": "application/json;charset=UTF-8",
				},
				url: `rejectReason/${id}`,
			});

			toast.success("Reject Reason deleted successfully!");
			return {
				data: resp.data.id,
				message: "success",
			};
		} catch (error) {
			toast.error("Error in deleting Reject Reason try again");
			console.log(error.message);
		}
	}
);


// rejectReason
export const getAllRejectReason = createAsyncThunk(
	"rejectReason/getAllRejectReason",
	async () => {
		try {
			const { data } = await axios.get(`rejectReason`);
			return data;
		} catch (error) {
			console.log(error.message);
		}
	}
);

export const updateRejectReason = createAsyncThunk(
	"rejectReason/updateRejectReason",
	async ({ id, values }) => {
		try {
			const { data } = await axios({
				method: "put",

				url: `rejectReason/${id}`,
				data: {
					...values,
				},
			});
			toast.success("Reject Reason updated successfully!");
			return {
				data,
				message: "success",
			};
		} catch (error) {
			toast.error("Error in updating Reject Reason try again");
			console.log(error.message);
			return {
				message: "error",
			};
		}
	}
);

const rejectReasonSlice = createSlice({
	name: "rejectReason",
	initialState,
	reducers: {
		clearRejectReason: (state) => {
			state.rejectReason = null;
		},
	},
	extraReducers: (builder) => {
		// 1) ====== builders for getAllRejectReason ======

		builder.addCase(getAllRejectReason.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(getAllRejectReason.fulfilled, (state, action) => {
			state.loading = false;
			state.list = action.payload;
		});

		builder.addCase(getAllRejectReason.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

		// 2) ====== builders for addRejectReason  ======

		builder.addCase(addRejectReason.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(addRejectReason.fulfilled, (state, action) => {
			state.loading = false;
		});

		builder.addCase(addRejectReason.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});




		// 3) ====== builders for updateRejectReason ======

		builder.addCase(updateRejectReason.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(updateRejectReason.fulfilled, (state, action) => {
			state.loading = false;
		});

		builder.addCase(updateRejectReason.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

		// 4) ====== builders for deleteRejectReason  ======

		builder.addCase(deleteRejectReason.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(deleteRejectReason.fulfilled, (state, action) => {
			state.loading = false;
		});

		builder.addCase(deleteRejectReason.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});
	},
});

export default rejectReasonSlice.reducer;
export const { clearRejectReason } = rejectReasonSlice.actions;
